import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  authApiClient,
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";
import {
  ChartDataResponse,
  OrgSetupProgressResponse,
  SubscriptionPlanResponse,
} from "./types";
// Add your feature-specific API calls here
export const onboardingSystemAdminApi = {
  getOrgSetupData: async (tenantId: string | null): Promise<OrgSetupProgressResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "org-setup-progress",
      (query) => {
        if (tenantId) {
          query.push("tenant_id", tenantId);
        }
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },
  getSubscriptionData: async (tenantId: string | null): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "subscription-plan-rate",
      (query) => {
        if (tenantId) {
          query.push("tenant_id", tenantId); 
        }
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },
  getChartData: async (tenantId: string | null): Promise<ChartDataResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "system-admin-dashboard-login-stats",
      (query) => {
        if (tenantId) {
          query.push("tenant_id", tenantId);
        }
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },
};